import { Button, notify } from '@affine/component';
import { UserSettingsService } from '@affine/core/modules/cloud';
import { useI18n } from '@affine/i18n';
import { useLiveData, useService } from '@toeverything/infra';
import { useEffect } from 'react';

import * as styles from './integrations-panel.css';

export const CalendarAccountColor = ({
  accountId,
  accountName,
  providerColor,
}: {
  accountId: string;
  accountName: string;
  providerColor?: string | null;
}) => {
  const t = useI18n();
  const settings = useService(UserSettingsService);
  const loaded = useLiveData(settings.userSettings$) !== undefined;
  const colors = useLiveData(settings.calendarAccountColors$);
  const color = colors.find(entry => entry.accountId === accountId)?.color;
  useEffect(() => settings.revalidate(), [settings]);

  const save = (color: string | null) => {
    settings.setCalendarAccountColor(accountId, color).catch(error => {
      notify.error({
        title: t['com.affine.integration.calendar.account.color-error'](),
        message: String(error),
      });
    });
  };

  return (
    <div
      className={styles.colorControls}
      onClick={event => event.stopPropagation()}
      onKeyDown={event => event.stopPropagation()}
    >
      <input
        type="color"
        className={styles.colorInput}
        aria-label={t['com.affine.integration.calendar.account.color']({
          account: accountName,
        })}
        title={t['com.affine.integration.calendar.account.color']({
          account: accountName,
        })}
        disabled={!loaded}
        value={
          color ??
          (providerColor && /^#[0-9a-f]{6}$/i.test(providerColor)
            ? providerColor
            : '#1e96eb')
        }
        onInput={event => save(event.currentTarget.value)}
      />
      <Button disabled={!loaded || !color} onClick={() => save(null)}>
        {t['com.affine.integration.calendar.account.reset-color']()}
      </Button>
    </div>
  );
};
